var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 13,
  viewBox: "0 0 17 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m8.187 13 7.9-6.25L8.173 0s.025 2.845.014 4C3.215 3.955 1.55 6.647.696 9.27c-.301.922-.566 1.862-.656 2.569C-.048 12.533.037 13 .037 13s3.173-3.254 4.76-3.5c1.9-.295 3.376-.25 3.376-.25z"
})));
export default SvgFacebookMobileShare;